<template>
    <BasicLayout :left='left' :middle='middle' :right='right'>
        <template  v-slot:right_view>
          <div  id='neTable' class='h100vh-140'>
            <div class="h-toolbarBg">
                <ejs-toolbar>
                    <e-items>
                        <e-item prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("MCS.add")' :click='addClick'></e-item>
                        <e-item prefixIcon='icon hero-icon hero-icon-edit' :tooltipText='$t("MCS.mod")' :click='modifyClk'></e-item>
                        <e-item prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("MCS.del")' :click='delClick'></e-item>
                        <e-item prefixIcon='icon hero-icon hero-icon-search' :tooltipText='$t("MCS.qry")' :click='queryClk'></e-item>
                    </e-items>
                </ejs-toolbar>
                <div class='h-inputBox'>
                    <ejs-textbox :placeholder='$t("Alarm.pleaseEnterTheQueryCriteria")' v-model='searchValue'></ejs-textbox>
                </div>
            </div>
            <div class='h100 width-100vw h-scroll'>
            <ejs-grid ref='gridTrunk' :dataSource="trunkdata" height=400  allowReordering='true' allowResizing='true' allowExcelExport='true' allowTextWrap='true'>
                <e-columns>
                    <e-column field='name' :headerText='$t("Topo.trunkName")'  textAlign='Center'> </e-column>
                    <e-column field='typeCode' :headerText='$t("Topo.trunkCode")' width='150' textAlign='Center' :valueAccessor='trunkTypeFormatter'></e-column>
                    <e-column field='ip' :headerText='$t("Topo.devIp")' width='150' textAlign='Center'></e-column>
                    <e-column field='port' :headerText='$t("Topo.devPort")' width='150' textAlign='Center'></e-column>
                    <e-column field='displaySoftwareVersion' :headerText='$t("Topo.devSoftVersion")' width='150' textAlign='Center'></e-column>
                    <!-- <e-column field='softwareVersion' :headerText='$t("Topo.physicalIP")' width='150' textAlign='Center'></e-column> -->
                </e-columns>
            </ejs-grid>
             <ejs-pager ref='trunkpager' @click='getTrunkListData()' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
            </div>
          </div>
          <CustomDialog ref='trunkdialog' :element='devDialog.element' :styles='devDialog.styles' :messages='devDialog.messages'>
            <template v-slot:dialog-content>
              <add-trunk ref="addtrunk" @close='addCancel' ></add-trunk>
            </template>
          </CustomDialog>
          <CustomDialog ref='updatetrunkdialog' :element='updatedevDialog.element' :styles='updatedevDialog.styles' :messages='updatedevDialog.messages'>
            <template v-slot:dialog-content>
              <UpdateTrunk ref="updatetrunk" @close='updateCancel' ></UpdateTrunk>
            </template>
          </CustomDialog>
       </template>
    </BasicLayout>
</template>

<style >
</style>

<script>
import BasicLayout from '../../../layouts/BasicLayout';
import CustomDialog from '../../../components/common/CustomDialog';
import AddTrunk from '../../../components/topoconfig/AddTrunk';
import UpdateTrunk from '../../../components/topoconfig/UpdateTrunk';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'trunkManage',
  components: {
    BasicLayout,
    CustomDialog,
    AddTrunk,
    UpdateTrunk
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb:  this.$t('Topo.trunkCrumb')
      },
      trunkdata: {},
      devDialog: {
        element: {
          title:  this.$t('Topo.trunkAdd'),
          // target: '#app',
          isClose: true,
          refName: this.$t('Topo.trunkMange'),
          buttonGroup: [
            { click: this.addCancel, buttonModel: { content: this.$t('Topo.cancel') } },
            { click: this.addSubmit, buttonModel: { content: this.$t('Topo.confirm'), isPrimary: true } }      
          ]
        },
        styles: {
          width: '680px',
          height: '575px',
          visible: false,
          model: true
        },
        messages: {
          title: this.$t('Topo.trunkAdd'),
        }
      },
      updatedevDialog: {
        element: {
          title:  this.$t('Topo.trunkModify'),
          // target: '#app',
          isClose: true,
          refName: this.$t('Topo.trunkMange'),
          buttonGroup: [
              { click: this.updateCancel, buttonModel: { content: this.$t('Topo.cancel') } },
            { click: this.updateSubmit, buttonModel: { content: this.$t('Topo.confirm'), isPrimary: true } },         
          ]
        },
        styles: {
          width: '680px',
          height: '575px',
          visible: false,
          model: true
        },
        messages: {
          title: this.$t('Topo.trunkModify'),
        }
      },
      searchValue: '',

      trunkTypemap: new Map()
        .set( 20001 , this.$t('Topo.trunkMC_CF'))
        .set( 20002 , this.$t('Topo.trunkHyTalk')),

      page: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0,
        pageCount: 10
      }
    };
  },
  mounted() {
    this.getTrunkListData();
  },
  methods: {
    addClick() {
      this.$refs.trunkdialog.show();
      this.$refs.addtrunk.bindValidate();
      this.$refs.addtrunk.queryTrunkType();
    },
    delClick() {
      const trunkIdVec = this.getCheckedVals(true);
      if (trunkIdVec) {
        this.$layer.confirm({
        msg: this.$t('Topo.sureDel'),
        btn1: {
          msg: this.$t('Topo.cancel')
        },
        btn2: {
          msg: this.$t('Topo.confirm'),
          func: this.delTrunk
        }
        });
      }
    },
    delTrunk(){
      const trunkIdVec = this.getCheckedVals(true);
      const params = JSON.stringify(trunkIdVec[0]);
      this.axios.get(`/lte/ems/topo/trunk/deleteTrunk/${params}`).then((response)=>{
        if(response.data === undefined){
          return;
        }
        if(response.status === 200){
          if (response.data.errorCode === 'SUCCESS') {
            this.getTrunkListData();
            EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
            return;
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        }
      });
    },

    getCheckedVals(selectOnly = false) {
      // x-> false: 不支持多选   true: 支持多选
      const deviceID = [];
      const checkedData = this.getCheckedData(selectOnly);
      for (let i = 0; i < checkedData.length; i++) {
        deviceID.push(checkedData[i].id);
      }
      return deviceID.length === 0 ? false : deviceID;
    },

    getCheckedData(selectOnly) {
      const selectedRecords = this.$refs.gridTrunk.getSelectedRecords();
      if (selectedRecords.length < 1) {
        console.log('1111',selectedRecords.length);
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Topo.pleaseSelect')});
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Topo.pleaseSelectOne')});
        return false;
      }
      return selectedRecords;
    },

    modifyClk() {
      const item = this.$refs.gridTrunk.getSelectedRecords();
      console.log('item',item)
      if (item.length === 1) {
        this.$refs.updatetrunkdialog.show();
        this.$refs.updatetrunk.initData(item[0]);
        this.$refs.updatetrunk.bindValidate();
      }
      if(item.length === 0) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Topo.pleaseSelect')});
        return;
      }
    },
    queryClk() {
       this.getTrunkListData();
    },
    addSubmit() {
      this.$refs.addtrunk.outputs();
      this.getTrunkListData();
    },
    addCancel() {
      this.$refs.trunkdialog.clear();
      this.$refs.trunkdialog.close();
      this.$refs.addtrunk.initData();
      this.getTrunkListData();
    },
    updateSubmit() {
      this.$refs.updatetrunk.outputs();
      this.getTrunkListData();
    },
    updateCancel() {
      this.$refs.updatetrunkdialog.clear();
      this.$refs.updatetrunkdialog.close();
      this.$refs.updatetrunk.initData();
      this.getTrunkListData();
    },
    trunkTypeFormatter(field, trunkdata) {
      return this.trunkTypemap.get(trunkdata.typeCode);
    },
    getTrunkListData() {
      // 获取表格数据
      const This = this;
      if(This.searchValue !==''){   //模糊搜索时页面初始化
        This.page.pageNo = 1;
      }
      else{
        This.page.pageNo = This.$refs.trunkpager.ej2Instances.currentPage;
      }
      this.$axios.get(`/lte/ems/topo/trunk/trunkPage?pageNo=${This.page.pageNo}&pageSize=${This.page.pageSize}&name=${This.searchValue}`)
      .then((response) => {
        console.log('responseTrunk1',response)
        if(response.data === undefined) {
          return;
        }
        if(response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {
            This.trunkdata = response.data.resultVal.result;
            This.page.totalCount = response.data.resultVal.totalCount;
            console.log('response.trunkdata',This.trunkdata);
          } else {
            console.log('responseTrunk2',response.data.errorString);
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        }
      });
    },
  }
};
</script>
